import { styled } from '@mui/material/styles';
import { Input } from 'components/ui';

const SearchTextField = styled(Input)(() => ({
  width: '100%',
}));

export { SearchTextField };
